type OperationSystemId = 'ios' | 'windows' | 'linux';

export function getBrowserOS(): OperationSystemId {
    const userAgent = window.navigator.userAgent,
        // @ts-ignore
        platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
        macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];

    if (macosPlatforms.indexOf(platform) !== -1) {
        return 'ios';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        return 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        return 'windows';
    } else if (/Android/.test(userAgent)) {
        return 'linux';
    } else if (/Linux/.test(platform)) {
        return 'linux';
    }

    return 'linux';
}
